/* erx-gc.js - gift card product page (sections/erx-gc-top.liquid). Ships with assets/erx-gc.css; layout atoms come
   from erx-pp.css. Runs the value pills, the "to me / to someone" switch, the live card preview, the gallery, and the
   add to cart with Shopify's gift card recipient properties (window.cart.addToCart takes no properties, so this posts
   /cart/add.js itself, then asks cart.js to repaint and open the drawer). */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const init = () => {
    const top = $('[data-erx-gc]'), dataEl = $('#erx-gc-data');
    if (!top || !dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const T = data.t || {};
    const input = $('#variant-id-input');
    const variants = data.variants || [];
    let variant = variants.find(v => String(v.id) === String(input && input.value)) || variants[0];
    if (!variant) return;
    const sample = ($('[data-erx-gc-now]', top) || {}).textContent || '';
    const money = cents => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(Math.round(cents));
      const n = (Math.round(cents) / 100).toFixed(2), [i, d] = n.split('.');
      const comma = /\d,\d{2}(?!\d)/.test(sample) || !/\d\.\d{2}(?!\d)/.test(sample);
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? ' ' : ',') + (comma ? ',' : '.') + d + ' €';
    };

    /* ---- value ---- */
    const pills = $$('[data-erx-gc-v]', top);
    const paint = () => {
      if (input) input.value = variant.id;
      window.currentSelectedVariant = String(variant.id);
      pills.forEach(p => {
        const on = p.dataset.erxGcV === String(variant.id);
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const pill = pills.find(p => p.dataset.erxGcV === String(variant.id));
      const fmt = (pill && pill.dataset.fmt) || money(variant.price);
      $$('[data-erx-gc-now]').forEach(el => { el.textContent = fmt; });
      $$('[data-erx-gc-barprice]').forEach(el => { el.textContent = fmt; });
      $$('[data-erx-gc-val]').forEach(el => { el.textContent = fmt; });
      const avail = variant.available !== false;
      $$('[data-erx-gc-atc]').forEach(b => {
        b.disabled = !avail;
        if (!b.hasAttribute('data-erx-gc-bar')) b.textContent = avail ? T.atc : T.soldOut;
      });
    };
    pills.forEach(p => p.addEventListener('click', () => {
      const v = variants.find(x => String(x.id) === p.dataset.erxGcV);
      if (!v) return;
      variant = v;
      paint();
      try { const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(history.state, '', url); } catch (e) {}
      showSlide(0);
    }));

    /* ---- to me / to someone ---- */
    let mode = 'me';
    const fields = $('[data-erx-gc-fields]', top), hintMe = $('[data-erx-gc-hint-me]', top);
    const email = $('[data-erx-gc-email]', top), name = $('[data-erx-gc-name]', top), from = $('[data-erx-gc-from]', top);
    const msg = $('[data-erx-gc-msg]', top), date = $('[data-erx-gc-date]', top), count = $('[data-erx-gc-count]', top);
    const errEmail = $('[data-erx-gc-err-email]', top), errDate = $('[data-erx-gc-err-date]', top);
    $$('[data-erx-gc-mode]', top).forEach(b => b.addEventListener('click', () => {
      mode = b.dataset.erxGcMode;
      $$('[data-erx-gc-mode]', top).forEach(x => {
        const on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (fields) fields.hidden = mode !== 'them';
      if (hintMe) hintMe.hidden = mode === 'them';
      if (mode === 'them' && email && !email.value) email.focus({ preventScroll: true });
      preview();
    }));

    /* the page may be served from cache: the date window follows the visitor's own today */
    const ymd = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const today = new Date();
    if (date) {
      date.min = ymd(today);
      const max = new Date(today); max.setDate(max.getDate() + 89); date.max = ymd(max);
    }

    /* ---- live card preview: the back of the paper card fills with to / from / message as the buyer types and comes to
       the front while they do; a tap on the card turns it back ---- */
    const duos = $$('[data-erx-gc-duo]', top);
    const val = el => (el && el.value || '').trim();
    const flip = on => duos.forEach(d => d.classList.toggle('is-flip', on));
    duos.forEach(d => d.addEventListener('click', () => d.classList.toggle('is-flip')));
    const preview = () => {
      const to = val(name), fr = val(from), m = val(msg);
      $$('[data-erx-gc-b-to]', top).forEach(el => { el.textContent = to; });
      $$('[data-erx-gc-b-from]', top).forEach(el => { el.textContent = fr; });
      $$('[data-erx-gc-b-msg]', top).forEach(el => { el.textContent = m; });
      if (count && msg) count.textContent = msg.value.length + '/200';
    };
    [name, from, msg].forEach(el => {
      if (!el) return;
      el.addEventListener('input', preview);
      el.addEventListener('focus', () => { showSlide(0); flip(true); });
    });
    if (email) email.addEventListener('input', () => { if (errEmail) errEmail.hidden = true; email.removeAttribute('aria-invalid'); });
    if (date) date.addEventListener('change', () => { if (errDate) errDate.hidden = true; });

    /* ---- gallery ---- */
    const dslots = $$('[data-erx-gc-dmain] .erx-pp-dgal__slot', top);
    const ths = $$('.erx-pp-dgal__th', top);
    let cur = 0;
    function showSlide(i) {
      if (!dslots.length) return;
      cur = (i + dslots.length) % dslots.length;
      dslots.forEach((s, k) => { s.hidden = k !== cur; s.classList.toggle('is-on', k === cur); });
      ths.forEach((t, k) => t.classList.toggle('is-on', k === cur));
    }
    ths.forEach((t, k) => t.addEventListener('click', () => showSlide(k)));
    const prev = $('[data-erx-gc-dprev]', top), next = $('[data-erx-gc-dnext]', top);
    if (prev) prev.addEventListener('click', () => showSlide(cur - 1));
    if (next) next.addEventListener('click', () => showSlide(cur + 1));

    const track = $('[data-erx-gc-ptrack]', top), dotsEl = $('[data-erx-gc-pdots]', top);
    if (track && dotsEl) {
      const slides = $$('.erx-pp-pgal__slide', track);
      dotsEl.innerHTML = slides.length > 1 ? '<span></span>'.repeat(slides.length) : '';
      const mark = () => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        $$('span', dotsEl).forEach((d, k) => d.classList.toggle('is-on', k === i));
      };
      track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
      mark();
    }

    /* ---- add to cart ---- */
    let adding = false;
    const fail = (el, err) => {
      if (err) err.hidden = false;
      if (el) { el.setAttribute('aria-invalid', 'true'); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); }
    };
    $$('[data-erx-gc-atc]').forEach(btn => btn.addEventListener('click', async e => {
      e.preventDefault();
      if (btn.disabled || adding) return;
      /* personal lines ride on the line in both modes: Shopify's own "Recipient name" / "Message" (its e-mail uses them)
         and "From"; templates/gift_card.liquid prints them on the printable card */
      const props = {};
      if (val(name)) props['Recipient name'] = val(name).slice(0, 40);
      if (val(from)) props['From'] = val(from).slice(0, 40);
      if (val(msg)) props['Message'] = val(msg).slice(0, 200);
      if (mode === 'them') {
        const em = val(email);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { fail(email, errEmail); return; }
        if (date && date.value && (date.value < date.min || date.value > date.max)) { fail(date, errDate); return; }
        props['Recipient email'] = em;
        if (date && date.value && date.value > date.min) props['Send on'] = date.value;
        props['__shopify_send_gift_card_to_recipient'] = 'on';
        props['__shopify_offset'] = String(new Date().getTimezoneOffset());
      }
      adding = true;
      const all = $$('[data-erx-gc-atc]');
      all.forEach(b => b.classList.add('is-busy'));
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: props }] })
        });
        if (!r.ok) {
          const body = await r.json().catch(() => ({}));
          console.error('[gift card] add failed', r.status, body && (body.description || body.message));
          if (mode === 'them' && /mail/i.test((body && body.description) || '')) fail(email, errEmail);
          return;
        }
        if (window.cart && window.cart.renderCart) {
          await window.cart.renderCart();
          if (window.cart.openDrawer) window.cart.openDrawer();
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[gift card] add error', err);
      } finally {
        adding = false;
        all.forEach(b => b.classList.remove('is-busy'));
      }
    }));

    /* phone sticky bar: only once the buy box's own button has scrolled away, never two "Į krepšelį" on one screen */
    const bar = $('.erx-pp-bar', top), own = $('.erx-gc-buy [data-erx-gc-atc]', top);
    if (bar && own && 'IntersectionObserver' in window) {
      bar.classList.add('erx-gc-bar');
      new IntersectionObserver(es => es.forEach(e => {
        bar.classList.toggle('is-off', e.isIntersecting || e.boundingClientRect.top > window.innerHeight);
      }), { threshold: 0 }).observe(own);
    }

    paint();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
